import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 600px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding-bottom: 8px;
`;

export const Content = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const highlightStyle = css`
  & strong {
    color: ${Palette.Primary._500};
    font-weight: inherit;
  }
`;
export const EmptySearchResult = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 32px;
  font-weight: 400;
  font-size: 0.75em;
  line-height: 1em;
  color: ${Palette.PrimaryGray._700};
`;

export const Item = styled.div`
  ${({ isActive }) =>
    isActive
      ? css`
          background: ${Palette.Primary._000};
          border: 1px solid ${Palette.Primary._300};
          border-radius: 4px;
        `
      : css`
          background: #ffffff;
          border: 1px solid #ffffff;
          border-radius: 4px;
        `}
  display: flex;
  align-items: center;
  height: 56px;
  margin: 8px 24px;
  padding: 8px;
  cursor: pointer;
  :hover {
    ${({ isActive }) =>
      isActive
        ? css`
                      background: ${Palette.PrimaryGray._100}
                      border: 1px solid ${Palette.Primary._300};
                      border-radius: 4px;
                  `
        : css`
            background: ${Palette.PrimaryGray._100};
            border: 1px solid #ffffff;
            border-radius: 4px;
          `}
  }
  :active {
    background: ${Palette.Primary._000};
    border: 1px solid ${Palette.Primary._300};
    border-radius: 4px;
  }
  transition: all 0.2s linear;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  img {
    height: 40px;
    width: 40px;
    border-radius: 4px;
  }
`;
export const ItemContent = styled.div`
  margin-left: 16px;
  width: calc(100% - 56px);
  display: flex;
  gap: 8px;
  justify-content: space-between;
`;
export const NameRow = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  ${highlightStyle}
`;

// export const Package = styled.div`
//   color: ${Palette.PrimaryGray._700};
//   font-weight: 400;
//   font-size: 12px;
//   line-height: 16px;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// `;
export const Data = styled.div`
  display: flex;
  color: ${Palette.PrimaryGray._700};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${highlightStyle}
`;

export const Id = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  margin-left: auto;
  color: ${Palette.PrimaryGray._700};
  &::before {
    content: 'App ID: ';
    color: ${Palette.PrimaryGray._500};
  }
`;
export const Message = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 32px;
  font-weight: 400;
  font-size: 0.75em;
  line-height: 1em;
  color: ${Palette.PrimaryGray._700};
`;

export const ItemsGroup = styled.div`
  margin-top: 8px;
`;

export const AppNumberBox = styled.div`
  align-self: flex-end;
  display: flex;
  justify-content: flex-end;
  gap: 2px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;
  flex-shrink: 0;
  p {
    color: ${Palette.PrimaryGray._500};
  }

  ${highlightStyle}
`;

export const LoaderWrap = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 32px;
  font-weight: 400;
  font-size: 0.75em;
  line-height: 1em;
  color: ${Palette.PrimaryGray._700};
`;
